import(/* webpackMode: "eager" */ "/vercel/path0/components/HeroVideo.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js")